import React, { useEffect, useState, useRef } from 'react'
import {
    Button,
    Col,
    Icon,
    Input,
    message,
    Modal,
    Row,
    Select,
    Table,
    Tag,
    Tooltip,
    Typography
} from 'antd';
import AstRecord from '../ast/AstRecord';
import LatestImage from '../../Asset/latest-image';
import './style.css'
import { Link } from 'react-router-dom';

function AssetsReconciliation({ data: assetData, voucher, locations, clients, astData, pvData, exportedData, setExportedData, ...props }) {
    const [columns, setColumns] = useState([])

    const [searchText, setsearchText] = useState('');
    const [searchedColumn, setsearchedColumn] = useState();
    const searchInput = useRef(null);

    const [data, setData] = useState([])

    // useEffect(() => {
    //     // console.log(astData);
    //     setData(assetData)
    // }, [assetData]);

    useEffect(() => {
        // console.log('I m ')
        if (assetData && assetData.length) {

            (astData || []).forEach(ast => {

                const status = ast.actionTaken && ast.actionTaken.name || '';
                if (status && ['RECONCILED', 'ATA_ARN', 'SOLD'].includes(status)) {
                    // console.log(ast.actionTaken);
                    if (ast.actionTaken && ast.actionTaken.refRecordId) {
                        const aIx = assetData.findIndex(d => d._id.toString() === ast.actionTaken.refRecordId.toString())
                        if (aIx >= 0) {
                            // console.log('Matched - ', assetData[aIx]);
                            assetData[aIx]['ast'] = ast

                            assetData[aIx]['status'] = ast.actionTaken
                            assetData[aIx]['original_status'] = ast.reconcileStatus
                            assetData[aIx]['process_remark'] = ast.processedRemark
                            // data[i]['ast'] = d
                            assetData[aIx]['isAlreadySaved'] = ast.isAlreadySaved
                            assetData[aIx]['isProcessed'] = ast.isProcessed

                            // data[i]['asset_before_location'] = data[i]['location']
                            // data[i]['asset_before_client'] = data[i]['client']
                        }
                    }

                }

            });

            (pvData || []).forEach(pv => {

                const status = pv.actionTaken && pv.actionTaken.name || '';
                if (status && ['LINK_ASSET'].includes(status) && pv.actionTaken.refRecordId) {
                    // console.log(pv.actionTaken);
                    const aIx = assetData.findIndex(d => d._id.toString() === pv.actionTaken.refRecordId.toString())
                    if (aIx >= 0) {
                        assetData[aIx]['pv'] = pv

                        // console.log('Matched -p ', assetData[aIx]);
                        // assetData[aIx]['ast'] = ast

                        assetData[aIx]['status'] = pv.actionTaken
                        assetData[aIx]['original_status'] = pv.reconcileStatus
                        assetData[aIx]['processed_remark'] = pv.processedRemark
                        // data[i]['ast'] = d
                        assetData[aIx]['isAlreadySaved'] = pv.isAlreadySaved
                        assetData[aIx]['isProcessed'] = pv.isProcessed
                    }
                }

            });
            // setData((data || []).filter(d => d.location && d.location.name !== 'SOLD'))

            setData(assetData)
        }
    }, [astData, pvData, assetData])

    //update master assets with ast details
    //   useEffect(() => {
    //     if (data && data.length && astData && astData.length) {
    //       const consideredAstData = astData.filter(as => as.isAlreadySaved || as.isProcessed)
    //       let isAssetUpdated = false
    //       consideredAstData.forEach(d => {
    //         if (d.actionTaken && d.actionTaken !== 'NEW_ASSET') {
    //           const i = masterAssets.findIndex(doc => doc.assetCode === d['assetCode'])
    //           if (i >= 0) {
    //             isAssetUpdated = true
    //             data[i]['status'] = d.actionTaken
    //             data[i]['ast'] = d
    //             data[i]['isAlreadySaved'] = d.isAlreadySaved
    //             data[i]['isProcessed'] = d.isProcessed

    //             data[i]['asset_before_location'] = data[i]['location']
    //             data[i]['asset_before_client'] = data[i]['client']
    //           }
    //         }
    //       })
    //       if (isAssetUpdated)
    //         setData([...data])
    //     }
    //   }, [data, astData])

    // useEffect(() => {
    //     console.log((data || []).filter(d => d.astast || d.pv));
    //     console.log((data || []).filter(d => !d.location || (d.location && d.location.name !== 'SOLD')));
    // }, [data])


    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput.current = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current.select(), 100);
            }
        },
        render: text => (dataIndex !== 'location' && dataIndex !== 'client') ?
            (
                text
            ) :
            dataIndex === 'location' ? (text && props.authUser && props.authUser.locations && props.authUser.locations.length)
                && props.authUser.locations.findIndex(loc => loc._id === text) >= 0 && props.authUser.locations[props.authUser.locations.findIndex(loc => loc._id === text)]['name']
                :
                dataIndex === 'client' ? (text && props.authUser && props.authUser.clients && props.authUser.clients.length)
                    && props.authUser.clients.findIndex(loc => loc._id === text) >= 0 && props.authUser.clients[props.authUser.clients.findIndex(loc => loc._id === text)]['name'] : ''
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setsearchText(selectedKeys[0]);
        setsearchedColumn(dataIndex);
    };

    const handleReset = clearFilters => {
        clearFilters();
        setsearchText('');
        // console.log(assetData);

        setData(assetData || [])
    };

    useEffect(() => {
        // const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
        // console.log(options)
        setColumns(
            [
                {
                    title: 'Asset',
                    dataIndex: 'assetCode',
                    key: 'assetCode',
                    ...getColumnSearchProps('assetCode'),
                },
                {
                    // Mirrors the master Asset list (src/containers/Asset/index.js "Photo" column):
                    // shows the asset's latest captured image as a thumbnail; click opens the
                    // full image carousel. Fetches per asset _id exactly like the masters list.
                    title: 'Photo',
                    key: 'photo',
                    render: (_, record) => record && record._id ? <LatestImage id={record._id} /> : null,
                },

                {
                    title: 'Location',
                    dataIndex: 'location',
                    key: 'location',
                    render: location => {
                        if (location && locations.length) {
                            const locIndex = locations.findIndex(loc => loc._id === location);
                            return locIndex >= 0 && locations[locIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('location'),
                    filters: (locations.map(l => ({ text: l.name, value: l._id }))),
                    onFilter: (value, record) => record.location && record.location.indexOf(value) === 0,
                },
                {
                    title: 'SubLocation',
                    dataIndex: 'client',
                    key: 'client',
                    render: client => {
                        if (client && clients.length) {
                            const clIndex = clients.findIndex(cl => cl._id === client);
                            return clIndex >= 0 && clients[clIndex]['name']
                        }
                    },
                    // ...getColumnSearchProps('client'),
                    filters: clients.map(c => ({ text: c.name, value: c._id })),
                    onFilter: (value, record) => record.client && record.client.indexOf(value) === 0,
                },
                {
                    title: 'Model',
                    dataIndex: 'assetModel',
                    key: 'assetModel',
                    render: assetModel => assetModel && assetModel.name
                },
                {
                    title: 'Sub Type',
                    dataIndex: 'equipmentSubType',
                    key: 'equipmentSubType',
                    render: equipmentSubType => equipmentSubType && equipmentSubType.name
                },
                {
                    title: 'Asset Type',
                    dataIndex: 'equipmentSubType',
                    key: 'assetType',
                    render: equipmentSubType => equipmentSubType && equipmentSubType.assetType && equipmentSubType.assetType.name
                },
                {
                    title: 'Original Status',
                    dataIndex: 'original_status',
                    key: 'original_status',
                    render: (_, record) => record.original_status
                },
                {
                    title: 'Rec. Status',
                    dataIndex: 'status',
                    key: 'status',
                    render: (_, record) => record.status && record.status.name
                },

                {
                    title: 'AST',
                    dataIndex: 'AST',
                    key: 'ast',
                    render: (_, record) => {
                        return (record.ast && record.ast.astNo) ? <Link target="_blank" to={`/asset-stock-taking/view/${record.ast._id}`}>
                            {record.ast.astNo}
                        </Link> : ''
                    },
                }, {
                    title: 'PV',
                    dataIndex: 'PV',
                    key: 'pv',
                    render: (_, record) => {
                        return (record.pv && record.pv.pvNo) ? <Link target="_blank" to={`/pre-verification/view/${record.pv._id}`}>
                            {record.pv.pvNo}
                        </Link> : ''
                    },
                },
                {
                    title: 'Process Remark',
                    dataIndex: 'processed_remark',
                    key: 'processed_remark',
                    render: (_, record) => record && record.processed_remark,
                },

            ]
        )
    }, [props.filters, data]);

    const rowClassName = (record) => {
        return record.isProcessed ? 'row-processed' : record.isAlreadySaved ? 'row-saved' : '';
    };

    const changeTable = (pagination, filters, sorter, extra) => {
        // console.log(pagination, filters);
        // console.log(extra);

        const { currentDataSource } = extra;
        setData(currentDataSource)

    }

    useEffect(() => {
        const { allAssets, pvAssets, astAssets } = exportedData || {};
        setExportedData({ allAssets: data, pvAssets, astAssets })
    }, [data])

    return (
        <div>
            {data && <Table size='small' dataSource={(data || []).filter(d => {
                // d.location is a location id string, not a populated object, so the old
                // d.location.name check never matched. Resolve the name via `locations`.
                if (!d.location) return true
                const loc = locations.find(l => l._id === d.location)
                return !loc || loc.name !== 'SOLD'
            })} columns={columns} rowKey={(record) => `${record.time}-${record._id}`} onChange={changeTable} rowClassName={rowClassName} />}

            <div style={{ float: 'right', marginTop: '10px' }}>
                <Button type="primary"
                    htmlType="button" loading={props.loading} onClick={null}>
                    Save
                </Button>
                <Button style={{ marginLeft: '5px' }} type="danger" htmlType="button" loading={props.loading}
                    onClick={null}>
                    Process Report
                </Button>
            </div>

        </div>
    )

}

export default AssetsReconciliation;
